import styled from "styled-components";
import InfoBox from "./InfoBox";

const ErrorBox = styled(InfoBox)`
  border-color: #cd7e87;
  background: #ffdcdf;
`;

export default ErrorBox;
